import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppRouter } from '@/app/router';
import '@/styles/index.css';
const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 5000, refetchOnWindowFocus: false } } });
createRoot(document.getElementById('root')).render(<StrictMode><QueryClientProvider client={queryClient}><AppRouter /></QueryClientProvider></StrictMode>);
